import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import TiGroup from 'react-icons/lib/ti/group'

export default class Viewers extends React.Component {
  static propTypes = {
    document: PropTypes.object
  }

  renderViewersCol(viewers) {
    return viewers.map(viewer => {
      return (
        <div className="row" key={viewer.email}>
          <div className={styles.Email}>{viewer.email}</div>
          <div className={styles.Signer}>{viewer.name}</div>
        </div>
      )
    })
  }

  render() {
    const viewers = this.props.document.viewers || []
    if (viewers.length === 0) return null
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <h3 className={styles.title}>Espectadores</h3>
            </div>
            <div className="col-xs-12 col-sm-10 end-md">
              <div className={styles.icon}>
                <TiGroup size={20} />
              </div>
            </div>
          </div>
        </div>
        <div className="content">{this.renderViewersCol(viewers)}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/Viewers/index.js